import React from 'react';
import Uppy from '@uppy/core';
import AwsS3 from '@uppy/aws-s3';
import { DragDrop, ProgressBar } from '@uppy/react';
import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/progress-bar/dist/style.min.css';

const API_URL = window.location.host.includes('localhost') ? 'http://localhost:3001' : 'https://enigmatic-shelf-39065.herokuapp.com';

export default class ImageUploader extends React.Component {

    constructor (props) {
        super(props);
        this.state = { file: [], featureImgUrl: [], uploadInProgress: false };
        this.uppy = Uppy({
            maxFileSize: 5000000,
            allowMultipleUploads: Boolean(props.allowMultiple) ? props.allowMultiple : false,
            locale: {
                strings: {
                    dropHereOr: `Drop image${props.allowMultiple ? 's' : ''} here or %{browse}`,
                }
            }
        })
        .use(AwsS3, {
            getUploadParameters(file) {
                return fetch(`${API_URL}/api/uploads/sign-url`, {
                    method: 'POST',
                    headers: new Headers({
                        'Authorization': `Bearer ${localStorage.getItem('id_token')}`,
                        accept: 'application/json',
                        'content-type': 'application/json'
                    }),
                    body: JSON.stringify({
                        filename: file.name,
                        contentType: file.type
                    })
                }).then(response => {
                    const json = response.json();
                    return json;
                }).then(data => {
                    return {
                        method: data.method,
                        url: data.url,
                        headers: data.header,
                    };
                }).catch(err => {
                    console.log(err);
                })
            }
        })
        .on('file-added', file => {
            const currentState = this.state.file.slice();
            currentState.push(file);
            this.setState({ file: currentState });
        });
    }

    componentWillUnmount () {
        this.uppy.close();
    }

    handleUpload() {
        this.setState({ uploadInProgress: true });
        this.props.beginUpload();
        this.uppy.upload().then(async result => {
            const featureImgs = this.state.featureImgUrl.slice();
            await result.successful.map(img => {
                if (img.response.status === 200) {
                    featureImgs.push(img.response.uploadURL);
                }
            });
            this.setState({ featureImgUrl: featureImgs });
            this.props.updateFeatureImg(featureImgs);
        });
    }

    render() {
        const { file, uploadInProgress } = this.state;
        return (
            <div>
                <DragDrop width="100%" height="250px" uppy={this.uppy} />
                {Boolean(file) && file.length > 0 &&
                    <div className="my-4">
                        {file.map(f => (
                            <div key={f.name}>{f.name}</div>
                        ))}
                        <button className={`mt-4 p-4 ${uploadInProgress ? 'bg-gray-600 cursor-not-allowed' : 'bg-west-green hover:bg-west-green-400'} items-center text-white leading-none lg:rounded-full flex lg:inline-flex`} onClick={() => this.handleUpload()}>{uploadInProgress ? 'Upload in progress..' : `Upload file${file.length > 1 ? 's' : ''}`}</button>
                    </div>
                }
                <div className="mt-2">
                    <ProgressBar uppy={this.uppy} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/image-uploader.js